module.exports = __webpack_public_path__ + "static/media/apaeselo.a723cfca.webp";